import { action, makeObservable } from 'mobx';

import NewListModel from 'shared/models/NewListModel';
import {
  CabinetManagerRoleEntity,
  CabinetManagerRoleType,
  IManagerRoleEntity,
  normalizeCabinetRoleEntity,
  normalizeProjectRoleEntity,
  ProjectManagerRoleEntity,
  ProjectManagerRoleType
} from 'shared/entities/manager';
import { apiUrls } from 'shared/entities/domain';
import { IRootStore } from 'shared/entities/store/rootStore';
import { TranslationString } from 'shared/entities/localization';
import { LoadingStageModel } from 'shared/models/loadingStage';

export default class ManagersRolesStore {
  readonly rootStore: IRootStore;

  readonly cabinetManagersRoles: NewListModel<
    IManagerRoleEntity<CabinetManagerRoleType>
  > = new NewListModel<IManagerRoleEntity<CabinetManagerRoleType>>();

  readonly projectManagersRoles: NewListModel<
    IManagerRoleEntity<ProjectManagerRoleType>
  > = new NewListModel<IManagerRoleEntity<ProjectManagerRoleType>>();

  readonly loadingStage: LoadingStageModel = new LoadingStageModel();

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      load: action.bound
    });
  }

  getCabinetRoleTitle(role: CabinetManagerRoleType): TranslationString | null {
    const roleEntity = this.cabinetManagersRoles.getEntity(role);

    return roleEntity ? roleEntity.name : null;
  }

  async load(): Promise<void> {
    if (this.loadingStage.isLoading) {
      return;
    }

    this.loadingStage.loading();

    const response = await this.rootStore.networkStore.api<{
      cabinet: CabinetManagerRoleEntity[];
      project: ProjectManagerRoleEntity[];
    }>(apiUrls.MANAGERS_LIST_ROLES);

    if (!response.isError) {
      this.projectManagersRoles.fillByRawData({
        raw: response.data.project,
        normalizer: (raw) => {
          return {
            entity: normalizeProjectRoleEntity(raw),
            key: raw.role
          };
        }
      });

      this.cabinetManagersRoles.fillByRawData({
        raw: response.data.cabinet,
        normalizer: (raw) => {
          return {
            entity: normalizeCabinetRoleEntity(raw),
            key: raw.role
          };
        }
      });
      this.loadingStage.success();
    } else {
      this.loadingStage.error();
    }
  }
}
